// extracted by mini-css-extract-plugin
export default {"List":"CafeList_List__Ll78F"};